import { render, staticRenderFns } from "./LideresBPO.vue?vue&type=template&id=0b8fc9aa"
import script from "./LideresBPO.vue?vue&type=script&lang=js"
export * from "./LideresBPO.vue?vue&type=script&lang=js"
import style0 from "./LideresBPO.vue?vue&type=style&index=0&id=0b8fc9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports